import { Check, Undo2 } from "lucide-react";

// Lote 120 (Robson, 25/10/2026) — botão "Marcar como feito": a bolinha cinza com o ✓ + a frase ao lado, numa linha própria
// (antes era uma bolinha solta colada na etiqueta do tipo, o que confundia). Depois de marcado vira "Feito ✓ · Desfazer".
// Prazo = "feito"; audiência/compromisso que já chegou = "realizada".
export default function MarcarFeito({ h, onToggleDone, className = "", testid = null, disabled = false, coluna = false }) {
  const prazo = (h.hearing?.event_type || "audiencia") === "prazo";
  const feito = h.prazo_done === true;
  const quando = prazo ? "feito" : "realizada";
  // Lote 123 (Robson, 25/10/2026): no celular, botão do mesmo formato do "Abrir", cinza bem claro, com "Concluir" escrito dentro, embaixo dele.
  if (coluna) {
    return (
      <button
        type="button"
        data-testid={testid || `prazo-done-toggle-${h.pub_id}`}
        data-feito={feito ? "1" : "0"}
        disabled={disabled}
        onClick={(e) => { e.stopPropagation(); onToggleDone(h); }}
        title={feito ? `Desfazer: voltar a ${prazo ? "pendente" : "não realizada"}` : `Marcar como ${quando}`}
        className={`inline-flex items-center justify-center gap-1.5 rounded-md px-2.5 h-9 text-xs font-semibold border transition-colors ${
          feito ? "bg-emerald-50 border-emerald-200 text-emerald-800" : "bg-stone-100 border-stone-200 text-stone-700 active:bg-stone-200"
        } ${className}`}
      >
        {feito ? <Undo2 className="w-3.5 h-3.5" strokeWidth={1.75} /> : <Check className="w-3.5 h-3.5" strokeWidth={2} />}
        {feito ? "Desfazer" : prazo ? "Concluir" : "Realizada"}
      </button>
    );
  }
  return (
    <button
      type="button"
      data-testid={testid || `prazo-done-toggle-${h.pub_id}`}
      disabled={disabled}
      data-feito={feito ? "1" : "0"}
      onClick={(e) => { e.stopPropagation(); onToggleDone(h); }}
      title={feito ? `Desfazer: voltar a ${prazo ? "pendente" : "não realizada"}` : `Marcar como ${quando}`}
      className={`inline-flex items-center gap-2 min-h-[36px] rounded-full pr-2 text-xs whitespace-nowrap font-semibold transition-colors ${
        feito ? "text-emerald-800 hover:text-emerald-900" : "text-stone-600 hover:text-emerald-brand"
      } ${className}`}
    >
      <span className={`inline-flex items-center justify-center w-6 h-6 rounded-full border shrink-0 ${
        feito ? "bg-emerald-100 border-emerald-300 text-emerald-700" : "bg-stone-100 border-stone-400 text-stone-600"
      }`}>
        {feito ? <Check className="w-3.5 h-3.5" strokeWidth={2.5} /> : <Check className="w-3.5 h-3.5" strokeWidth={2.5} />}
      </span>
      {feito ? (
        <span className="inline-flex items-center gap-1">{prazo ? "Feito" : "Realizada"} <span className="text-stone-400 font-normal">·</span> <Undo2 className="w-3 h-3" strokeWidth={2} /> Desfazer</span>
      ) : (
        <span>Marcar como {quando}</span>
      )}
    </button>
  );
}
